import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "transfer-options" };
const _hoisted_2 = { class: "transfer-options__title" };
const _hoisted_3 = {
    key: 1,
    class: "transfer-options__info"
};
const _hoisted_4 = { class: "transfer-options__param" };
const _hoisted_5 = { class: "transfer-options__label" };
const _hoisted_6 = { class: "transfer-options__value" };
const _hoisted_7 = { class: "transfer-options__param" };
const _hoisted_8 = { class: "transfer-options__label" };
const _hoisted_9 = { class: "transfer-options__value" };
const _hoisted_10 = { class: "transfer-options__param" };
const _hoisted_11 = { class: "transfer-options__label" };
const _hoisted_12 = { class: "transfer-options__value" };
import { onMounted, ref } from 'vue';
import palomaInput from "@astina/paloma-common-ui/src/services/PalomaInput";
import CopyToClipboard from "@astina/paloma-common-ui/src/components/CopyToClipboard.vue";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import exportProfileRepository from "../services/ShopExportProfileRepository";
import ExportProfileInputPassword from "./ExportProfileInputPassword.vue";
import CurrentlyUnavailable from "./CurrentlyUnavailable.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExportProfileTransferSftp',
    props: {
        profileId: {}
    },
    setup(__props) {
        const props = __props;
        const profile = ref(null);
        const transferInformation = ref(null);
        const unavailable = ref(false);
        onMounted(() => {
            loadExportProfile();
            loadTransferInformation();
        });
        function loadExportProfile() {
            exportProfileRepository
                .get(props.profileId)
                .then(p => profile.value = p);
        }
        function loadTransferInformation() {
            unavailable.value = false;
            palomaInput
                .getTransferInformation()
                .then(data => transferInformation.value = data)
                .catch(() => unavailable.value = true);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('export_profile.sftp_connection_info')), 1),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _createVNode(Spinner, {
                    loading: (!transferInformation.value || !profile.value) && !unavailable.value
                }, null, 8, ["loading"]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                (unavailable.value)
                    ? (_openBlock(), _createBlock(CurrentlyUnavailable, { key: 0 }))
                    : _createCommentVNode("", true),
                _cache[8] || (_cache[8] = _createTextVNode()),
                (transferInformation.value && profile.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('import_profile.transfer.host')), 1),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_6, [
                                _createTextVNode(_toDisplayString(transferInformation.value.sftp.host) + " ", 1),
                                _createVNode(CopyToClipboard, {
                                    value: transferInformation.value.sftp.host
                                }, null, 8, ["value"])
                            ])
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('import_profile.transfer.port')), 1),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_9, [
                                _createTextVNode(_toDisplayString(transferInformation.value.sftp.port) + " ", 1),
                                _createVNode(CopyToClipboard, {
                                    value: transferInformation.value.sftp.port.toString()
                                }, null, 8, ["value"])
                            ])
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('import_profile.transfer.username')), 1),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_12, [
                                _createTextVNode(_toDisplayString(profile.value.inputUsername) + " ", 1),
                                _createVNode(CopyToClipboard, {
                                    value: profile.value.inputUsername
                                }, null, 8, ["value"])
                            ])
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createVNode(ExportProfileInputPassword, { profile: profile.value }, null, 8, ["profile"])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
